import ArrowBackIcon from "@mui/icons-material/ArrowBackIosNew";
import { BaseButtonProps, Button } from "../Button";

export interface PaginationPrevProps
  extends
    BaseButtonProps,
    Omit<React.ComponentPropsWithoutRef<"button">, "color"> {}
export const PaginationPrev = (props: PaginationPrevProps) => {
  return <Button icon={<ArrowBackIcon />} {...props} />;
};
